import {gql} from '@apollo/client';
import {useLazyQuery} from '@apollo/client/react';

// Droits nécessaires : ADMIN_INVOICE ou USER_INVOICE
const GET_CONSULTANT_INVOICE = gql`
  query ConsultantInvoice($uuid: ID!) {
    consultantInvoice(uuid: $uuid) {
      amountClient
      amountClientEur
      amountConsultant
      amountConsultantEur
      boondManagerInvoiceId
      clientName
      commission
      commissionEur
      currency
      dailyRateClient
      dailyRateClientEur
      dailyRateConsultant
      dailyRateConsultantEur
      daysWorked
      invoiceDate
      invoiceNumber
      manualCommission
      month
      paymentDate
      periodEnd
      periodStart
      uuid
      year
    }
  }
`;

export const useConsultantInvoice = () => {
  const [getConsultantInvoice, { loading, error, data, refetch }] = useLazyQuery(GET_CONSULTANT_INVOICE, {
    fetchPolicy: "network-only",
  });

  return {
    loading,
    error,
    data: data?.consultantInvoice,
    refetch,
    getConsultantInvoice: (uuid) => getConsultantInvoice({ variables: { uuid } }),
  };
};
